import type { EntityId } from './common';

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  DEVELOPER: 'DEVELOPER',
  CLIENT: 'CLIENT',
  AFFILIATE: 'AFFILIATE',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export interface User {
  id: EntityId;
  name: string;
  email: string;
  role: UserRole;
  organization: string;
  active: boolean;
}

export const INVITATION_STATUSES = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
} as const;

export type InvitationStatus = typeof INVITATION_STATUSES[keyof typeof INVITATION_STATUSES];

export const INVITATION_DELIVERY_STATUSES = {
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  FAILED: 'FAILED',
} as const;

export type InvitationDeliveryStatus = typeof INVITATION_DELIVERY_STATUSES[
  keyof typeof INVITATION_DELIVERY_STATUSES
];

export interface Invitation {
  id: EntityId;
  email: string;
  role: UserRole;
  status: InvitationStatus;
  expiresAt: string;
  deliveryStatus: InvitationDeliveryStatus;
  createdAt: string;
}

export interface CreateInvitationRequest {
  email: string;
  role: UserRole;
}
